export { default } from './InternalCamBadge';
